import {
  SET_HISTORY_CREATE_SURVEY,
  SET_STEP_CREATE_SURVEY,
  CLEAR_CREATE_SURVEY,
  SET_OPEN_DOWNLOAD,
  SET_OPEN_CREATE_OPTIONS,
  SET_OPEN_SCHEDULE,
  SET_OPEN_CANCEL_SCHEDULE,
} from 'store/types/survey';

export const setHistoryCreateSurvey = (history) => {
  return {
    type: SET_HISTORY_CREATE_SURVEY,
    payload: history,
  };
};

export const setStepCreateSurvey = (step) => {
  return {
    type: SET_STEP_CREATE_SURVEY,
    payload: step,
  };
};

export const setOpenDownload = (download) => {
  return {
    type: SET_OPEN_DOWNLOAD,
    payload: download,
  };
};

export const setOpenCreateOptions = (openCreateOptions) => {
  return {
    type: SET_OPEN_CREATE_OPTIONS,
    payload: openCreateOptions,
  };
};

export const clearCreateSurvey = () => {
  return {
    type: CLEAR_CREATE_SURVEY,
    payload: null,
  };
};

export const setOpenSchedule = (openSchedule) => {
  return {
    type: SET_OPEN_SCHEDULE,
    payload: openSchedule,
  };
};

export const setOpenCancelSchedule = (openCancelSchedule) => {
  return {
    type: SET_OPEN_CANCEL_SCHEDULE,
    payload: openCancelSchedule,
  };
};
